export default {
  dashboard: [
    {
      title: 'User Guide',
      route: 'dashboard-guide',
      icon: 'HelpCircleIcon',
      resource: 'sikanii',
      action: 'access-sikanii-app',
    },
  ],
  account: [
    {
      title: 'Company Account',
      route: 'company-account',
      icon: 'HomeIcon',
      resource: 'account',
      action: 'access-company-account',
    },
    {
      title: 'User Accounts',
      route: 'user-accounts',
      icon: 'UsersIcon',
      resource: 'account',
      action: 'access-user-accounts',
    },
    {
      title: 'Notifications',
      route: 'notifications',
      icon: 'MessageCircleIcon',
      resource: 'account',
      action: 'access-notifications',
    },
    {
      title: 'Failed SMS',
      route: 'failed-sms',
      icon: 'XCircleIcon',
      resource: 'account',
      action: 'access-failed-sms',
    },
    {
      title: 'SMS Settings',
      route: 'sms-settings',
      icon: 'SettingsIcon',
      resource: 'account',
      action: 'access-sms-settings',
    },
    {
      title: 'Subscription',
      route: 'subscription',
      icon: 'PackageIcon',
      resource: 'account',
      action: 'access-subscription',
    },
    {
      title: 'User Activities',
      route: 'user-activities',
      icon: 'ActivityIcon',
      resource: 'account',
      action: 'access-user-activities',
    },
    {
      title: 'User Guide',
      route: 'account-guide',
      icon: 'HelpCircleIcon',
      resource: 'sikanii',
      action: 'access-sikanii-app',
    },
  ],
  savings_and_loans: [
    {
      title: 'Dashboard',
      icon: 'BarChartIcon',
      route: 'susu-dashboard',
      resource: 'savings_and_loans',
      action: 'access-dashboard',
    },
    {
      title: 'Performance',
      icon: 'PieChartIcon',
      route: 'susu-performance',
      resource: 'savings_and_loans',
      action: 'access-performance',
    },
    {
      title: 'Customers',
      icon: 'UsersIcon',
      route: 'customers',
      resource: 'savings_and_loans',
      action: 'access-customers',
    },
    {
      title: 'Transactions',
      route: 'transactions',
      icon: 'CalendarIcon',
      resource: 'savings_and_loans',
      action: 'access-transactions',
    },
    {
      title: 'Loans',
      route: 'loans',
      icon: 'BriefcaseIcon',
      resource: 'savings_and_loans',
      action: 'access-loans',
    },
    {
      title: 'Loan Payments',
      route: 'loan-payments',
      icon: 'CreditCardIcon',
      resource: 'savings_and_loans',
      action: 'access-loan-payments',
    },
    {
      title: 'Funds Transfer',
      route: 'funds-transfer',
      icon: 'TrendingUpIcon',
      resource: 'savings_and_loans',
      action: 'access-funds-transfer',
    },
    {
      title: 'Fixed Deposits',
      route: 'fixed-deposits',
      icon: 'PlusIcon',
      resource: 'savings_and_loans',
      action: 'access-fixed-deposits',
    },
    {
      title: 'Loan Calculator',
      route: 'loan-calculator',
      icon: 'PlusSquareIcon',
      resource: 'savings_and_loans',
      action: 'access-loan-calculator',
    },
    {
      title: 'Expenses',
      route: 'expenses',
      icon: 'DollarSignIcon',
      resource: 'general',
      action: 'access-expenses',
    },
    {
      title: 'User Guide',
      route: 'savings-guide',
      icon: 'HelpCircleIcon',
      resource: 'sikanii',
      action: 'access-sikanii-app',
    },
  ],
  hire_purchase: [
    {
      title: 'Dashboard',
      route: 'dashboard',
      icon: 'BarChartIcon',
      resource: 'hire_purchase',
      action: 'access-dashboard',
    },
    {
      title: 'Performance',
      icon: 'PieChartIcon',
      route: 'performance',
      resource: 'hire_purchase',
      action: 'access-performance',
    },
    {
      title: 'Purchasers',
      route: 'purchasers',
      icon: 'UsersIcon',
      resource: 'hire_purchase',
      action: 'access-purchasers',
    },
    {
      title: 'Items',
      route: 'items',
      icon: 'HeartIcon',
      resource: 'hire_purchase',
      action: 'access-items',
    },
    {
      title: 'Contracts',
      route: 'contracts',
      icon: 'BriefcaseIcon',
      resource: 'hire_purchase',
      action: 'access-contracts',
    },
    {
      title: 'Payments',
      route: 'contract-payments',
      icon: 'ClipboardIcon',
      resource: 'hire_purchase',
      action: 'access-contract-payments',
    },
    {
      title: 'Cash Sales',
      route: 'cash-sales',
      icon: 'CreditCardIcon',
      resource: 'hire_purchase',
      action: 'access-cash-sales',
    },
    {
      title: 'Expenses',
      route: 'expenses',
      icon: 'DollarSignIcon',
      resource: 'general',
      action: 'access-expenses',
    },
    {
      title: 'User Guide',
      route: 'hire-guide',
      icon: 'HelpCircleIcon',
      resource: 'sikanii',
      action: 'access-sikanii-app',
    },
  ],
  group_susu: [
    {
      title: 'User Guide',
      route: 'susu-guide',
      icon: 'HelpCircleIcon',
      resource: 'sikanii',
      action: 'access-sikanii-app',
    },
  ],
}
